import { createContext, useContext } from '@wordpress/element';

const LicenseContext = createContext();

export const useLicense = () => {
  const ctx = useContext(LicenseContext);
  if (!ctx) throw new Error('useLicense must be used within LicenseProvider');
  return ctx;
};

export default LicenseContext;